<template>
  <div id="chartLine" class="chart"></div>
</template>

<script>
export default {
  // props: ['stockCode', 'stockName', 'historyData'],
  data() {
    return {
      factorId: '',
      chartLineDate: [], // 折线时间
      chartLineData: [], // 折线数值
    }
  },
  created() {
    this.token = this.$route.query.token
    // this.token = this.$store.state.token
    this.themeStyleVs = this.$route.query.themeStyleVs
    this.factorId = this.$route.query.indexId
    this.getLineData()
  },
  watch: {
    stockCode() {
      this.chartDom.clear();
      this.getKData()
    }
  },
  methods: {
    // 获取折线数据
    getLineData () {
      var postParam = {
        qid: new Date().getTime(),
        param: {
          factorId: this.factorId,
        }
      }
      this.$http({
        method:'post',
        url: window.config.research_server + '/research-framework-server/rf/fm/idx/fvs',
        data: postParam,
        headers: {
          token: this.token
        }
      }).then((res) =>{
        var result = []
        var newResult = []
        if (res.data.data.length > 0) {
          result = res.data.data
          result.forEach(element => {
            if(element.v !='' && element.v != undefined) {
              newResult.push(element)
            }
          })
          newResult.forEach(element=>{
            this.chartLineDate.push(element.t)
            this.chartLineData.push(element.v)
          })
          this.drawLine()
        }
      })
    },
    drawLine2() {
      this.$nextTick(()=>{
        if (!this.chartDom) {
        this.chartDom = this.$echarts.init(document.getElementById('chartKLine'))
      } else {
          this.chartDom.dispose()
          this.chartDom = this.$echarts.init(document.getElementById('chartKLine'))
      }
      // 默认展示246条数据
      var start = Math.floor((1 - 246/this.chartLineDate.length) * 100)
       var dataZoom =
      [{
        type: 'inside',
        start,
        end: 100,
      }, {
        type: 'slider',
        start,
        end: 100,
        left: 7,
        right: 12,
        brushSelect: false,
        handleSize: 20,
        handleIcon: this.themeStyleVs == 1 ?  "image://images/handle.png" : "image://images/handle-black.png",
        handleStyle: {
          color: '#fff'
        },
        height: 20,
        backgroundColor: this.themeStyleVs == 1 ? "rgba(250, 250, 250, 1)" : 'rgba(30, 32, 43, 1)',
        borderColor: this.themeStyleVs == 1 ? "rgba(250, 250, 250, 1)" : 'rgba(30, 32, 43, 1)'
      }]
      var option = {
        grid:{
          top: 30,
          bottom: 20,
          left: 50,
          right: 30,
            containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: this.chartLineDate,
          axisLabel: {
            fontSize: 11,
            margin: 10,
            show: true,
            color: this.themeStyleVs == 1 ? 'rgba(0,0,0,0.3)' : 'rgba(255, 255, 255, 0.4)',
            showMaxLabel: true
          },
          axisLine: {
            lineStyle: {
              color: this.themeStyleVs == 1 ? 'rgba(0,0,0,0.05)' : 'rgba(0,0,0,0)',
              width: 0.5,
              show: false
            }
          },
          axisTick: {
            lineStyle: {
              color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.1)' : 'rgba(237, 237, 237, 0.08)',
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            splitLine:{
              show: true,
              lineStyle:{
                color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0)',
                // color: 'red',
                width: 0.5
              }
            },
            axisLabel: {
              color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.3)' : 'rgba(255, 255, 255, 0.4)',
              formatter: function (value) {
                return value.toFixed(2);
              },
              fontSize: 10,
              margin: 5
            },
            max: function (value) {
              return Math.floor(value.max) + 2;
            },
            min: function (value) {
              return Math.floor(value.min) - 2;
            }
          },
        ],
        series: [
          {
            data: this.chartKLData1,
            name: '指标',
            type: 'line',
            symbolSize: 0,
            lineStyle: {
              width: 2,
              color: this.themeStyleVs == 1 ? '#286DF7' : '#3B85FE'
            },
            connectNulls: true,
          }

        ]
      }
      if (this.chartLineDate.length > 246) { // 超过246条，出现滚动条
          option.dataZoom = dataZoom
          option.grid.bottom = 75
        }
      this.chartDom.setOption(option)
      })

    },
    drawLine() {
      if (document.getElementById('chartLine')) {
        var chartLine = this.$echarts.init(document.getElementById('chartLine'))
        var option = {
          grid: {
            top: 30,
            bottom: 20,
            left: 50,
            right: 30
          },
          tooltip: {
            trigger: 'axis',
            formatter: function(param) {
              return  param[0].axisValue + '<br/>' +'指标：' + param[0].value
            }
          },
          xAxis: {
            type: 'category',
            data: this.chartLineDate,
            show: true,
            position: 'bottom',
            axisLabel: {
              fontSize: 11,
              margin: 10,
              show: true,
              color: this.themeStyleVs == 1 ? 'rgba(0,0,0,0.3)' : 'rgba(255, 255, 255, 0.4)',
               showMaxLabel: true
            },
            axisLine: {
              lineStyle: {
                color: this.themeStyleVs == 1 ? 'rgba(0,0,0,0.05)' : 'rgba(0,0,0,0)',
                width: 0.5,
                show: false
              }
            },
            axisTick: {
              lineStyle: {
                color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.1)' : 'rgba(237, 237, 237, 0.08)',
              }
            }
          },
          yAxis: {
            type: 'value',
            splitLine:{
              show: true,
              lineStyle:{
                color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0)',
                // color: 'red',
                width: 0.5
              }
            },
            axisLabel: {
              color: this.themeStyleVs == 1 ?  'rgba(0,0,0,0.3)' : 'rgba(255, 255, 255, 0.4)',
              formatter: function (value) {
                return value.toFixed(2);
              },
              fontSize: 10,
              margin: 5
            },
            max: function (value) {
              return Math.floor(value.max) + 2;
            },
            min: function (value) {
              return Math.floor(value.min) - 2;
            }
          },
          series: [
            {
              data: this.chartLineData,
              type: 'line',
              symbolSize: 0,
              lineStyle: {
                width: 2,
              }
            }
          ]
        }
        chartLine.setOption(option)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .chart{
    width: 100%;
    height: 100%;
  }
</style>